import { Descriptions } from 'antd';
import type React from 'react';
import dayjs from '@/utils/dayjs-instance';

interface DriverMetricsProps {
  startTime: string | null;
  lastActivity: string | null;
  departmentTimeZone: number;
}

const formatActivityTime = (isoString: string | null, departmentTimeZone: number): string => {
  if (!isoString) return '-';
  return dayjs
    .utc(isoString)
    .utcOffset(departmentTimeZone * 60)
    .format('HH:mm');
};

export const DriverMetrics: React.FC<DriverMetricsProps> = ({
  startTime,
  lastActivity,
  departmentTimeZone,
}) => {
  return (
    <Descriptions
      size="small"
      column={2}
      style={{ padding: '0 16px 8px' }}
      items={[
        {
          key: 'startTime',
          label: 'Start Time',
          children: (
            <span data-testid="metric-start-time">
              {formatActivityTime(startTime, departmentTimeZone)}
            </span>
          ),
        },
        {
          key: 'lastActivity',
          label: 'Last Activity',
          children: (
            <span data-testid="metric-last-activity">
              {formatActivityTime(lastActivity, departmentTimeZone)}
            </span>
          ),
        },
      ]}
    />
  );
};
